import { Metadata } from 'next'

const title = 'About Us | Ship&Play'
const description =
  'Explore the Ship&Play family of brands and how luggage shipping makes each trip, big or ' +
  'small, easier for every traveler.'
const url = 'https://www.shipplay.com/about'
const image = 'https://media.shipplay.com/ship-sticks-og-image.png'

const metadata: Metadata = {
  title,
  description,
  alternates: {
    canonical: url,
  },
  openGraph: {
    type: 'website',
    url,
    siteName: 'Ship&Play',
    title,
    description,
    images: [
      {
        url: image,
        width: 1200,
        height: 630,
        alt: 'About Ship&Play — luggage shipping for every kind of traveler',
      },
    ],
  },
  twitter: {
    card: 'summary_large_image',
    title,
    description,
    images: [image],
  },
}

export default metadata
